import React from 'react';
import { motion } from 'framer-motion';
import { Hero } from '../components/Hero';
import { ProblemSection } from '../components/ProblemSection';
import { OpeningLead } from '../components/OpeningLead';
import { EditorialTips } from '../components/EditorialTips';
import { PdfPreview } from '../components/PdfPreview';
import { Testimonials } from '../components/Testimonials';
import { WhatYouGet } from '../components/WhatYouGet';
import { Bonuses } from '../components/Bonuses';
import { PricingSection } from '../components/PricingSection';
import { Guarantee } from '../components/Guarantee';
import { FAQ } from '../components/FAQ';
import { StickyCTA } from '../components/StickyCTA';
import { Footer } from '../components/Footer';
import { CTAButton } from '../components/CTAButton';
import { useCurrency } from '../hooks/useCurrency';
export function SalesPage() {
  const {
    formatPrice
  } = useCurrency();
  const goToCheckout = () => {
    if (typeof window !== 'undefined' && window.fbq) {
      window.fbq('track', 'AddToCart', {
        content_name: 'The Nap-Trapped Reset',
        content_type: 'product',
        value: 14,
        currency: 'USD'
      });
    }
    window.open('https://www.gemmamama.com/cart/45389317111947:1', '_blank');
  };
  return <div className="min-h-screen bg-cream font-sans selection:bg-sage/20" data-id="element-603">
      <Hero data-id="element-604" />
      <ProblemSection data-id="element-605" />
      <OpeningLead data-id="element-606" />
      <EditorialTips data-id="element-607" />
      <Testimonials data-id="element-608" />
      <PdfPreview data-id="element-609" />
      <WhatYouGet data-id="element-610" />
      <Bonuses data-id="element-611" />
      <PricingSection data-id="element-612" />
      <Guarantee data-id="element-613" />
      <FAQ data-id="element-614" />

      {/* Final CTA */}
      <section className="relative py-16 md:py-24 px-6 text-center bg-cream-dark overflow-hidden" data-id="element-615">
        {/* Subtle ambient glow */}
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-terracotta/4 rounded-full blur-[100px] pointer-events-none" data-id="element-616" />

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8,
        ease: [0.25, 0.1, 0.25, 1]
      }} className="max-w-2xl mx-auto relative z-10" data-id="element-617">
          {/* Decorative accent */}
          <div className="w-12 h-px bg-terracotta/30 mx-auto mb-8" data-id="element-618" />

          <p className="text-xs uppercase tracking-[0.2em] text-terracotta font-bold mb-6" data-id="element-619">
            Your calm starts here
          </p>

          <h2 className="font-serif text-3xl md:text-5xl text-brown mb-5 leading-tight" data-id="element-620">
            You don't need perfect naps. <br className="hidden md:block" data-id="element-621" />
            You need <span className="text-terracotta italic" data-id="element-622">30 minutes</span>.
          </h2>

          <p className="font-serif text-lg md:text-xl text-brown/60 italic mb-10 leading-relaxed" data-id="element-623">
            Less than a coffee. Yours forever.
          </p>

          <CTAButton text="Give Me My 30 Minutes" onClick={goToCheckout} data-id="element-624" />

          <p className="text-xs text-brown-light/50 mt-6 tracking-wide uppercase font-medium" data-id="element-625">
            Instant PDF · Phone-friendly · 14-day guarantee
          </p>
        </motion.div>
      </section>

      <Footer data-id="element-626" />
      <StickyCTA data-id="element-627" />
    </div>;
}